<template>
  <div
    :class="[
      `formulate-input-element formulate-input-element--${context.type} input-${size}`,
      variant && `text-input--${variant}`,
      underline && 'text-input--underline',
    ]"
    :data-type="context.type"
  >
    <FormulateSlot name="prefix" :context="context">
      <component
        :is="context.slotComponents.prefix"
        v-if="context.slotComponents.prefix"
        :context="context"
      />
    </FormulateSlot>
    <input
      v-model="context.model"
      type="text"
      v-bind="context.attributes"
      :class="{ 'text-input--clearable': canClear }"
      :placeholder="(context.attributes && context.attributes.placeholder) || context.label"
      @blur="context.blurHandler"
      @input="handleInput"
    />
    <button
      v-if="canClear && clearable"
      type="button"
      class="text-input__clear"
      aria-label="Hapus isi input"
      @mousedown.prevent
      @click="clear"
    >
      <i class="icon-fill_close-circle" />
    </button>
    <FormulateSlot name="suffix" :context="context">
      <component
        :is="context.slotComponents.suffix"
        v-if="context.slotComponents.suffix"
        :context="context"
      />
    </FormulateSlot>
  </div>
</template>

<script>
// Known Issues:
// Can't use `mask.lazy = true` (showing mask placeholder)
// since we are directly editing the model value

import maskFieldValue from './lib/maskFieldValue.js'

export default {
  props: {
    context: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      default: 'md',
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: '',
    },
    underline: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    canClear() {
      return (
        this.context.model !== '' &&
        this.context.model !== null &&
        this.context.model !== undefined &&
        !this.context.attributes?.disabled &&
        !this.context.attributes?.readonly
      )
    },
  },
  methods: {
    clear() {
      // Vue Formulate exposes the field model through its input context.
      // eslint-disable-next-line vue/no-mutating-props
      this.context.model = ''
    },
    handleInput(e) {
      if ('mask' in this.context.attributes) {
        const masked = maskFieldValue(e.target.value, this.context.attributes.mask)
        // eslint-disable-next-line vue/no-mutating-props
        this.context.model = masked
      }
    },
  },
}
</script>
<style lang="scss" scoped>
$color-underline: #cbd0dc;
$color-clear: #67718b;
$color-clear-focus: #d6e0ff;
$clear-size: 16px;

$variants: (danger, #fee8e6, #f41d00), (success, #e7f2ee, #137c55);

.formulate-input-element {
  position: relative;
}

.text-input {
  &--clearable {
    padding-right: 26px !important;
  }

  &--underline > input {
    background-color: transparent;
    border: 0 !important;
    border-bottom: 1px solid $color-underline !important;
    box-shadow: none;
    outline: none;
    transition: border-color 0.15s;

    &:focus {
      border-radius: 2px !important;
    }
  }

  @each $name, $bg, $border in $variants {
    &--#{$name} > input {
      background-color: $bg;
      border-color: $border !important;

      &:focus {
        border-color: $border !important;
      }
    }
  }

  &__clear {
    position: absolute;
    top: 50%;
    right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: $clear-size;
    height: $clear-size;
    padding: 0;
    color: $color-clear;
    background: transparent;
    border: 0;
    cursor: pointer;
    transform: translateY(-50%);

    &:focus-visible {
      outline: 2px solid $color-clear-focus;
    }
  }
}
</style>
